import React from "react";
import { Phone, Mail, MapPin, Instagram, Facebook, GraduationCap } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden text-white"
      style={{ background: "#0B132B" }}
    >
      <div className="px-4 sm:px-6 md:px-12 lg:px-16 pt-16 sm:pt-20 pb-10 max-w-[1400px] mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <span className="w-9 h-9 rounded-2xl bg-[#FF6B6B] grid place-items-center">
                <GraduationCap size={18} strokeWidth={2.4} />
              </span>
              <span className="font-display text-xl font-extrabold tracking-tight">
                LearnWith<span className="text-[#FF6B6B]">Nova</span>
              </span>
            </div>
            <p className="text-white/70 max-w-sm leading-relaxed">
              A tuition where curiosity is celebrated and growth is measured beyond marks. Grade 1 to grade 12 — Five years of nurturing each student.
            </p>
            <div className="flex items-center gap-3 mt-8">
              <a
                href="#"
                className="w-11 h-11 rounded-full grid place-items-center bg-white/8 hover:bg-[#FF6B6B] transition-colors"
                data-testid="footer-social-instagram"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href="#"
                className="w-11 h-11 rounded-full grid place-items-center bg-white/8 hover:bg-[#FF6B6B] transition-colors"
                data-testid="footer-social-facebook"
                aria-label="Facebook"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.25em] uppercase font-bold text-[#FF6B6B] mb-4">Visit</div>
            <ul className="space-y-3 text-white/85">
              <li className="flex gap-3"><MapPin size={16} className="mt-1 flex-shrink-0 text-[#4ECDC4]" /> Nova Learn Centre (Surya Complex opposite to St Ritas Hospital), Nalukody Junction, Changanassery</li>
              <li className="flex gap-3"><Phone size={16} className="mt-1 flex-shrink-0 text-[#4ECDC4]" /> +91 70127 08655</li>
              <li className="flex gap-3"><Mail size={16} className="mt-1 flex-shrink-0 text-[#4ECDC4]" /> learnwithnova@gmail.com</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] tracking-[0.25em] uppercase font-bold text-[#FF6B6B] mb-4">Hours</div>
            <ul className="space-y-2 text-white/85">
              <li className="flex justify-between border-b border-white/10 py-2"><span>Mon — Sat</span><span className="text-white/60">6 AM — 9 PM</span></li>
              <li className="flex justify-between border-b border-white/10 py-2"><span>Sunday</span><span className="text-white/60">Closed</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 sm:mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs sm:text-sm text-white/55">
          <div>© {new Date().getFullYear()} LearnWithNova Tuition</div>
          <div className="flex gap-6">
            <a href="#" className="link-underline">Privacy</a>
            <a href="#" className="link-underline">Terms</a>
            <a href="#enroll" className="link-underline">Enroll</a>
          </div>
        </div>
      </div>

      <div
        className="font-display font-black tracking-tighter leading-none whitespace-nowrap select-none pointer-events-none absolute -bottom-6 left-0 right-0 text-center text-white/[0.06]"
        style={{ fontSize: "22vw" }}
        aria-hidden="true"
      >
        LearnWithNova
      </div>
    </footer>
  );
}
